import React from 'react';
import clsx from 'clsx';

import { useSlider } from '@edx/hooks/use-slider';
import { IconAngleLeft, IconAngleRight } from '@edx/components/icons';

export const Slider: React.FC = ({ children }) => {
  const {
    ref,
    canGoPrev,
    canGoNext,
    selectedIndex,
    scrollSnaps,
    handleScrollPrev,
    handleScrollNext,
    handleScrollTo,
  } = useSlider();

  return (
    <>
      <div className="flex list-none justify-end space-x-2">
        {scrollSnaps.map((_, index: number) => (
          <button
            key={index}
            className="relative w-6 h-6 cursor-pointer bg-transparent p-0 outline-none border-0 flex items-center focus:outline-none"
            type="button"
            onClick={(): void => handleScrollTo(index)}
          >
            <span className={clsx('bg-white h-0.5 w-full', index === selectedIndex ? 'bg-white' : 'bg-gray-600')} />
          </button>
        ))}
      </div>

      <div className="relative mx-auto max-w-full">
        <div className="w-full overflow-hidden" ref={ref}>
          <div className="flex">{children}</div>
        </div>

        {canGoPrev && (
          <div className="hidden md:flex items-center absolute left-0 inset-y-0">
            <button
              className="w-14 h-14 px-4 py-1 bg-gray-800 flex justify-center items-center focus:outline-none"
              onClick={handleScrollPrev}
            >
              <IconAngleLeft className="w-full h-full text-white" />
            </button>
          </div>
        )}

        {canGoNext && (
          <div className="hidden md:flex items-center absolute right-0 inset-y-0">
            <button
              className="w-14 h-14 px-4 py-1 bg-gray-800 flex justify-center items-center focus:outline-none"
              onClick={handleScrollNext}
            >
              <IconAngleRight className="w-full h-full text-white" />
            </button>
          </div>
        )}
      </div>
    </>
  );
};
